define('TescoMobile_Checkout/js/model/create-device-fingerprint-url',['Magento_Customer/js/model/customer', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/url-builder'], function (customer, quote, urlBuilder) {
  'use strict';

  return function () {
    return customer.isLoggedIn() ? urlBuilder.createUrl('/carts/mine/set-device-fingerprint', {}) : urlBuilder.createUrl('/guest-carts/:cartId/set-device-fingerprint', {
      cartId: quote.getQuoteId()
    });
  };
});

